import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import QuoteForm from "./pages/QuoteForm";
import ServiceAreas from "./pages/ServiceAreas";
import SuburbLanding from "./pages/SuburbLanding";
import LeaveReview from "./pages/LeaveReview";
import Admin from "./pages/Admin";
import Playbook from "./pages/Playbook";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import AirbnbTurnoverPage from "./pages/AirbnbTurnoverPage";
import { Toaster } from "./components/ui/sonner";
import Analytics from "./components/Analytics";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Analytics />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quote" element={<QuoteForm />} />
          <Route
            path="/services/airbnb-turnover-cleaning"
            element={<AirbnbTurnoverPage />}
          />
          <Route path="/cleaning" element={<ServiceAreas />} />
          <Route path="/cleaning/:suburb" element={<SuburbLanding />} />
          <Route path="/leave-a-review" element={<LeaveReview />} />
          <Route path="/marketing-playbook" element={<Playbook />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
